import System from '@/_system.js'

export default {
	methods: {
		async cdvAlert(title, message, cb, button) {
      await System.toast({
        text: [title, message].filter(el => !!el).join(', '),
      })
		},
	}
}
